import BloodGroup from "./bloodGroup";
export default BloodGroup;